const HANDYMAN_SOCIAL_IMAGE_PATH =
  '/static/services/handyman/handyman-furniture-assembly-portrait.jpg';

const createAbsoluteImageUrl = (rootUrl, imagePath) => {
  const normalizedRootUrl = (rootUrl || '').replace(/\/$/, '');
  return `${normalizedRootUrl}${imagePath}`;
};

export const createHandymanSocialSharing = (rootUrl, title, description) => {
  const imageUrl = createAbsoluteImageUrl(rootUrl, HANDYMAN_SOCIAL_IMAGE_PATH);
  const squareImage = {
    url: imageUrl,
    width: 600,
    height: 600,
    alt: title,
  };

  return {
    title,
    description,
    twitterCard: 'summary',
    images1200: [squareImage],
    images600: [squareImage],
  };
};

